import { withLocalState } from 'pyradux';

import UsersContainer from './Users.container';
import reducer from './Users.reducer';
import UsersSagas from './Users.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'users',
  sagas: [UsersSagas],
};

export default withLocalState(withLocalStateOptions, UsersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Users/index.js